//import { apiService } from "@/_services";
import { timeFormat } from "d3";
import axios from "axios";

export function downloadDataModelTable(_this) {
  let token = localStorage.getItem("token");
  let endpoint = "download_currency_exposures_file";
  let formatTime = timeFormat("%Y-%m-%d");
  var filename =
    _this.companies[_this.selectedCompany].company_name.replace(/ /g, "_") +
    "_" +
    formatTime(new Date())
  axios
    .get(`${process.env.VUE_APP_URL}/${endpoint}/`, {
      responseType: "blob",
      headers: { Authorization: "Bearer " + token },
      params: { origin: _this.selection, filename: filename }
    })
    .then(response => {
      var contentType = "application/vnd.ms-excel.sheet.macroEnabled.12";
      var formatTime = timeFormat("%Y-%m-%d");
      var filename =
        _this.companies[_this.selectedCompany].company_name.replace(/ /g, "_") +
        "_" +
        formatTime(new Date()) + ".xlsm";

      var blob = new Blob([response.data], { type: contentType });

      var downloadUrl = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      _this.modal_processing_message.showModalLoading = false;
    });
}
